import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import { useDispatch } from 'react-redux';
import { androidApi } from "../../../services/iPhoneApiService";
import { addToCart } from "../../../store/actions/cart";
import { isEmpty } from "../../../validation/index";
import LoaderSpinner from "../../Loader/loaderSpinner";
import att from './Carrier/att.png';
import EditIcon from '@material-ui/icons/Edit'
import cricket from './Carrier/cricket.png';
import sprint from './Carrier/sprint.png';
import tmobile from './Carrier/tmobile.png';
import usCellular from './Carrier/usCellular.png';
import verizon from './Carrier/verizon.png';
import xfinity from './Carrier/xfinity.png';
import Edit from "@material-ui/icons/Edit";

const deviceList = [
    {
        device: 'Galaxy Z-Fold Series',
        deviceLabel: 'GalaxyZFoldSeries',
        devicePhoto: 'https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/galaxy-z-fold-series.jpg',
        modal: [
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_Fold_5.webp',
                label: "Galaxy Fold5",
                capacity:  ["256 GB","512 GB", "1 TB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_Fold_5.webp"
            },
           
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_Fold_4.webp',
                label: "Galaxy Fold4",
                capacity: ["256 GB","512 GB", "1 TB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_Fold_4.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_z_fold_3_5g.png',
                label: "Galaxy Fold3 5G",
                capacity: ["256 GB","512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_z_fold_3_5g.png"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_z_fold_2_5g.webp',
                label: "Galaxy Fold2 5G",
                capacity: ["256 GB","512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_z_fold_2_5g.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_fold.webp',
                label: "Galaxy Fold",
                capacity: [],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_fold.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_z_flip_5.webp',
                label: "Galaxy Z-Flip5",
                capacity: ["256 GB","512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_z_flip_5.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_z_flip_4.webp',
                label: "Galaxy Z-Flip4",
                capacity: ["128 GB","256 GB","512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_z_flip_4.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_z_flip_3_5g.webp',
                label: "Galaxy Z-Flip3 5G",
                capacity: ["128 GB","256 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_z_flip_3_5g.webp"
            }
            ,
             {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_x_flip_5g.webp',
                label: "Galaxy Z-Flip 5G",
                capacity: [],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_x_flip_5g.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_z_flip.webp',
                label: "Galaxy Z-Flip",
                capacity: [],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_Z-flip/Galaxy_z_flip.webp"
            },
        ]
    },
    {
        device: 'Galaxy S Series',
        deviceLabel: 'GalaxySSeries',
        devicePhoto: 'https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/galaxy-s-series.jpg',
        modal: [
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/s23_fe.webp',
                label: "Galaxy S23 FE",
                capacity: ["128 GB", "256 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/s23_fe.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/s23_ultra.webp',
                label: "Galaxy S23 Ultra",
                capacity: ["256 GB", "512 GB", "1 TB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/s23_ultra.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S23_Plus.webp',
                label: "Galaxy S23 Plus",
                capacity: ["128 GB", "256 GB","512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S23_Plus.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S23.webp',
                label: "Galaxy S23",
                capacity: ["128 GB", "256 GB","512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S23.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S22_ultra_5g.png',
                label: "Galaxy S22 Ultra 5G",
                capacity: ["128 GB", "256 GB","512 GB","1 TB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S22_ultra_5g.png"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S22_Plus_5g.png',
                label: "Galaxy S22 Plus 5G",
                capacity: ["128 GB","256 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S22_Plus_5g.png"
            },
            {
                devicePhoto:'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S22_5g.png',
                label: "Galaxy S22 5G",
                capacity: ["128 GB","256 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S22_5g.png"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S21_Ultra_5g.webp',
                label: "Galaxy S21 Ultra 5G",
                capacity: ["128 GB","256 GB","512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S21_Ultra_5g.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S21_Ultra.webp',
                label: "Galaxy S21 Ultra",
                capacity:  ["128 GB","256 GB","512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S21_Ultra.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S21_Plus_5g.webp',
                label: "Galaxy S21 Plus 5G",
                capacity: ["128 GB", "256 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S21_Plus_5g.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S21_5G.webp',
                label: "Galaxy S21 5G",
                capacity: ["128 GB","256 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S21_5G.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S21_FE_5G.webp',
                label: "Galaxy S21 FE 5G",
                capacity:["128 GB","256 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S21_FE_5G.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S20_Plus_5g.webp',
                label: "Galaxy S20 Plus 5G",
                capacity: ["128 GB","512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S20_Plus_5g.webp"
            },
           
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S20_Plus.webp',
                label: "Galaxy S20 Plus",
                capacity: ["128 GB","512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S20_Plus.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S20.jpg.webp',
                label: "Galaxy S20",
                capacity: [],
                carrier: [],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S20.jpg.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S20_FE-5G.webp',
                label: "Galaxy S20 FE 5G",
                capacity: ["128 GB","256 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S20_FE-5G.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S20_FE_jpg.webp',
                label: "Galaxy S20 FE",
                capacity: ["128 GB", "256 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S20_FE_jpg.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S20-5g.jpg.webp',
                label: "Galaxy S20 5G",
                capacity: [],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S20-5g.jpg.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S10-lite.jpg.webp',
                label: "Galaxy S10 Lite",
                capacity: [],
                carrier: [],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S10-lite.jpg.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S10-5g.jpg.webp',
                label: "Galaxy S10 5G",
                capacity: ["256 GB", "512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S10-5g.jpg.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S10-plus.jpg.webp',
                label: "Galaxy S10 Plus",
                capacity: ["128 GB", "512 GB", "1 TB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S10-plus.jpg.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S10.jpg.webp',
                label: "Galaxy S10",
                capacity: ["128 GB", "512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S10.jpg.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S10e.jpg.webp',
                label: "Galaxy S10e",
                capacity: ["128 GB", "256 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S10e.jpg.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S9-plus.jpg.webp',
                label: "Galaxy S9 Plus",
                capacity: ["64 GB", "128 GB", "256 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S9-plus.jpg.webp"
            },
            {
                devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S9.jpg.webp',
                label: "Galaxy S9",
                capacity: ["64 GB", "128 GB", "256 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Samsung_s-series/S9.jpg.webp"
            },

        ]
    },
    {
        device: 'Galaxy Note Series',
        deviceLabel: 'GalaxyNoteSeries',
        devicePhoto: 'https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/galaxy-note-series.jpg',
        modal: [
            {
                devicePhoto: 'https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/Galaxy+Note+10+plus160.jpg',
                label: "Galaxy Note 20 Ultra 5G",
                capacity: ["128 GB","256 GB", "512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/Galaxy+Note+10+plus160.jpg"
            },
            {
                devicePhoto: 'https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/Galaxy+Note+10+plus160.jpg',
                label: "Galaxy Note 20 Ultra",
                capacity: ["128 GB","256 GB", "512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/Galaxy+Note+10+plus160.jpg"
            },
            {
                devicePhoto: 'https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/Galaxy+Note+10+plus160.jpg',
                label: "Galaxy Note 20 5G",
                capacity: ["128 GB","256 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/Galaxy+Note+10+plus160.jpg"
            },
            {
                devicePhoto: 'https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/Galaxy+Note+10+plus160.jpg',
                label: "Galaxy Note 10 Plus 5G",
                capacity: ["256 GB", "512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/Galaxy+Note+10+plus160.jpg"
            },
            {
                devicePhoto: 'https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/galaxy-note10-160.jpg',
                label: "Galaxy Note 10 Plus",
                capacity: ["256 GB", "512 GB"],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/galaxy-note10-160.jpg"
            },

            {
                devicePhoto: 'https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/galaxy-note10-160.jpg',
                label: "Galaxy Note 10 Lite",
                capacity: [],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/galaxy-note10-160.jpg"
            },
            {
                devicePhoto: 'https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/galaxy-note10-160.jpg',
                label: "Galaxy Note 10",
                capacity: [],
                carrier: [
                    {
                        label: 'Bell',
                       
                    },
                    {
                        label: 'Rogers',
                      
                    },
                    {
                        label: 'Fido',
                        
                    },
                    {
                        label: 'Telus',
                       
                    },
                    {
                        label: 'Unlocked'
                    },
                    {
                        label: 'other'
                    }
                ],
                imagePath: "https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/galaxy-note10-160.jpg"
            },
            {
                devicePhoto: 'https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/galaxy-note-9.jpg',
                label: "Galaxy Note 9",
                capacity: ["128 GB", "512 GB"],
                carrier: [
                    {
            label: 'Bell',
           
        },
        {
            label: 'Rogers',
          
        },
        {
            label: 'Fido',
            
        },
        {
            label: 'Telus',
           
        },
        {
            label: 'Unlocked'
        },
        {
            label: 'other'
        }
                ],
                imagePath: "https://cashmydevice-frontend.s3-us-west-1.amazonaws.com/Samsung+/galaxy-note-9.jpg"
            },
            
        ]
    }

]

const AndroidPage = (props) => {
    const dispatch = useDispatch();
    const [selectedDevice, setSelectedDevice] = useState()
    const [offers, setOffers] = useState()
    const [imagePath, setImagePath] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const [deviceDetails, setDeviceDetails] = useState()
    const [isCapacity, setCapCity] = useState(false);
    const [isShowButton, setIsShowButton] = useState(false)

    const [isBrokenOrNo, setIsBrokenOrNo] = useState(false)
    const [isBrokenFiled, setIsBrokenFiled] = useState(false)
    const [isCarrier, setCarrier] = useState(false)

    const selectDevice = (obj) => {
        setSelectedDevice([obj])
    }

    const handelSubmits = (value) => {
        setIsLoader(true);
        const condition = value.condition === '100%' ? '100%' : value.condition === '75%' ? '75%' : value.condition === '50%' ? '50%' : value.condition === 'Broken' ? 'Broken' : 'Broken'
        
        const obj = {
            samsung_model: value.deviceType,
            samsung_capacity: value.capacity,
            samsung_carrier: value.carrier,
            samsung_condition: condition,
            samsung_functional: value.functional,
            samsung_powercord: value.powercord ? 'Yes' : value.powercord === 'No' ? 'No%' : '',
            samsung_box: value.box ? 'Yes' : value.box === 'No' ? 'No%' : '',
            samsung_headset: value.headsets ? 'Yes' : value.headsets === 'No' ? 'No%' : '',
            samsung_screenburn: '',
            samsung_isunlock: ''
        }
        let customAmount = 0;
        console.log(obj)
        console.log(condition)
if (obj.samsung_model === "Galaxy Fold5") {
                obj.samsung_capacity = "256 GB";
                obj.samsung_carrier = "unlocked";
                obj.samsung_functional="";
                obj.samsung_powercord = '';
                obj.samsung_box = '';
                obj.samsung_headset = '';
               if(obj.samsung_condition==="100%"){
                    customAmount=customAmount
                    if(value.carrier==="Bell"  || value.carrier==="other"){
                        customAmount-=30
                    }
                    if(value.carrier==="Fido"){
                        customAmount-=15
                    }
                    if(value.carrier==="Rogers"){
                        customAmount-=15
                    }
                    if(value.carrier==="Telus"){
                        customAmount-=15
                    }
                    if(value.capacity==="512 GB"){
                        customAmount+=15
                    }
                    if(value.capacity==="1 TB"){
                        customAmount+=15
                    }
               }
               if(obj.samsung_condition==="75%"){
                customAmount=customAmount
                if(value.carrier==="Bell"  || value.carrier==="other"){
                    customAmount-=30
                }
                if(value.carrier==="Fido"){
                    customAmount-=15
                }
                if(value.carrier==="Rogers"){
                    customAmount-=15
                }
                if(value.carrier==="Telus"){
                    customAmount-=15
                }
                if(value.capacity==="512 GB"){
                    customAmount+=15
                }
                if(value.capacity==="1 TB"){
                    customAmount+=15
                }
                if(value.functional==="Yes"){
                    customAmount=customAmount
                }
                
                if(value.functional==="No"){
                    customAmount-=customAmount
                }
                if (obj.samsung_box==="Yes") {
                    customAmount += 1;
                }
                if (obj.samsung_box==="No%") {
                    customAmount -= 1;
                }
                if (obj.samsung_headset==="Yes") {
                    customAmount += 1;
                }
                if (obj.samsung_headset==="No%") {
                    customAmount += 1;
                }
                if (obj.samsung_powercord==="Yes") {
                    customAmount += 1;
                }
                if (obj.samsung_powercord==="No%") {
                    customAmount -= 1;
                }
           }
           if(obj.samsung_condition==="50%"){
            customAmount=customAmount
            if(value.carrier==="Bell"  || value.carrier==="other"){
                customAmount-=30
            }
            if(value.carrier==="Fido"){
                customAmount-=15
            }
            if(value.carrier==="Rogers"){
                customAmount-=15
            }
            if(value.carrier==="Telus"){
                customAmount-=15
            }
            if(value.capacity==="512 GB"){
                customAmount+=15
            }
            if(value.capacity==="1 TB"){
                customAmount+=15
            }
            if(value.functional==="Yes"){
                customAmount=customAmount
            }
            
            if(value.functional==="No"){
                customAmount-=customAmount
            }
            if (obj.samsung_box==="Yes") {
                customAmount += 1;
            }
            if (obj.samsung_box==="No%") {
                customAmount -= 1;
            }
            if (obj.samsung_headset==="Yes") {
                customAmount += 1;
            }
            if (obj.samsung_headset==="No%") {
                customAmount += 1;
            }
            if (obj.samsung_powercord==="Yes") {
                customAmount += 1;
            }
            if (obj.samsung_powercord==="No%") {
                customAmount -= 1;
            }
       }
        if(condition==="Broken"){
            customAmount-=customAmount
        }
    }
else if(obj.samsung_model === "Galaxy Fold4") {
            obj.samsung_capacity = "256 GB";
            obj.samsung_carrier = "unlocked";
            obj.samsung_functional="";
            obj.samsung_powercord = '';
            obj.samsung_box = '';
            obj.samsung_headset = '';
    if(obj.samsung_condition==="100%"){
            customAmount=customAmount
                if(value.carrier==="Bell"  || value.carrier==="other"){
                    customAmount-=30
                }
                if(value.carrier==="Fido"){
                    customAmount-=15
                }
                if(value.carrier==="Rogers"){
                    customAmount-=15
                }
                if(value.carrier==="Telus"){
                    customAmount-=15
                }
                if(value.capacity==="512 GB"){
                    customAmount+=15
                }
                if(value.capacity==="1 TB"){
                    customAmount+=15
                }
        }
        if(obj.samsung_condition==="75%"){
            customAmount=customAmount
            if(value.carrier==="Bell"  || value.carrier==="other"){
                customAmount-=30
            }
            if(value.carrier==="Fido"){
                customAmount-=15
            }
            if(value.carrier==="Rogers"){
                customAmount-=15
            }
            if(value.carrier==="Telus"){
                customAmount-=15
            }
            if(value.capacity==="512 GB"){
                customAmount+=15
            }
            if(value.capacity==="1 TB"){
                customAmount+=15
            }
            if(value.functional==="Yes"){
                customAmount=customAmount
            }
            
            if(value.functional==="No"){
                customAmount-=customAmount
            }
            if (obj.samsung_box==="Yes") {
                customAmount += 1;
            }
            if (obj.samsung_box==="No%") {
                customAmount -= 1;
            }
            if (obj.samsung_headset==="Yes") {
                customAmount += 1;
            }
            if (obj.samsung_headset==="No%") {
                customAmount += 1;
            }
            if (obj.samsung_powercord==="Yes") {
                customAmount += 1;
            }
            if (obj.samsung_powercord==="No%") {
                customAmount -= 1;
            }
    }
    if(obj.samsung_condition==="50%"){
        customAmount=customAmount
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        if(value.capacity==="1 TB"){
            customAmount+=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }
        
        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
    }
    if(condition==="Broken"){
        customAmount-=customAmount
    }
}
else if(obj.samsung_model === "Galaxy Fold3 5G") {
    obj.samsung_capacity = "256 GB";
    obj.samsung_carrier = "unlocked";
    obj.samsung_functional="";
    obj.samsung_powercord = '';
    obj.samsung_box = '';
    obj.samsung_headset = '';
    if(obj.samsung_condition==="100%"){
        customAmount=customAmount
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        
    }
    if(obj.samsung_condition==="75%"){
        customAmount-=15
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
       
        if(value.functional==="Yes"){
            customAmount=customAmount
        }
        
        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
}
    if(obj.samsung_condition==="50%"){
    customAmount-=30
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }

        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
}
    if(condition==="Broken"){
        customAmount-=customAmount
}
}
else if(obj.samsung_model === "Galaxy Fold2 5G") {
    obj.samsung_capacity = "256 GB";
    obj.samsung_carrier = "unlocked";
    obj.samsung_functional="";
    obj.samsung_powercord = '';
    obj.samsung_box = '';
    obj.samsung_headset = '';
    if(obj.samsung_condition==="100%"){
        customAmount=customAmount
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        
    }
    if(obj.samsung_condition==="75%"){
        customAmount-=15
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
       
        if(value.functional==="Yes"){
            customAmount=customAmount
        }
        
        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
}
    if(obj.samsung_condition==="50%"){
    customAmount-=30
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }

        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
}
    if(condition==="Broken"){
        customAmount-=customAmount
}
}
else if(obj.samsung_model === "Galaxy Fold2 5G") {
    obj.samsung_capacity = "256 GB";
    obj.samsung_carrier = "unlocked";
    obj.samsung_functional="";
    obj.samsung_powercord = '';
    obj.samsung_box = '';
    obj.samsung_headset = '';
    if(obj.samsung_condition==="100%"){
        customAmount=customAmount
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        
    }
    if(obj.samsung_condition==="75%"){
        customAmount-=15
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
       
        if(value.functional==="Yes"){
            customAmount=customAmount
        }
        
        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
}
    if(obj.samsung_condition==="50%"){
    customAmount-=30
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }

        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
}
    if(condition==="Broken"){
        customAmount-=customAmount
}
}
else if(obj.samsung_model === "Galaxy Fold") {
    obj.samsung_capacity = "";
    obj.samsung_carrier = "unlocked";
    obj.samsung_functional="";
    obj.samsung_powercord = '';
    obj.samsung_box = '';
    obj.samsung_headset = '';
    if(obj.samsung_condition==="100%"){
        customAmount=customAmount
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        
        
    }
    if(obj.samsung_condition==="75%"){
        customAmount-=15
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }
        
        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
}
    if(obj.samsung_condition==="50%"){
    customAmount-=30
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }

        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
}
    if(condition==="Broken"){
        customAmount-=customAmount
}
}
else if(obj.samsung_model === "Galaxy Z-Flip5") {
    obj.samsung_capacity = "256 GB";
    obj.samsung_carrier = "unlocked";
    obj.samsung_functional="";
    obj.samsung_powercord = '';
    obj.samsung_box = '';
    obj.samsung_headset = '';
    if(obj.samsung_condition==="100%"){
        customAmount=customAmount
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        
        
    }
    if(obj.samsung_condition==="75%"){
        customAmount-=15
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }
        
        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
}
    if(obj.samsung_condition==="50%"){
    customAmount-=30
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }

        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
}
    if(condition==="Broken"){
        customAmount-=customAmount
}
}
else if(obj.samsung_model === "Galaxy Z-Flip4") {
    obj.samsung_capacity = "128 GB";
    obj.samsung_carrier = "unlocked";
    obj.samsung_functional="";
    obj.samsung_powercord = '';
    obj.samsung_box = '';
    obj.samsung_headset = '';
    if(obj.samsung_condition==="100%"){
        customAmount=customAmount
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        if(value.capacity==="256 GB"){
            customAmount+=15
        }
        
        
    }
    if(obj.samsung_condition==="75%"){
        customAmount-=15
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }
        
        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        if(value.capacity==="256 GB"){
            customAmount+=15
        }
}
    if(obj.samsung_condition==="50%"){
    customAmount-=30
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }

        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        if(value.capacity==="256 GB"){
            customAmount+=15
        }
}
    if(condition==="Broken"){
        customAmount-=customAmount
}
}
else if(obj.samsung_model === "Galaxy Z-Flip3 5G") {
    obj.samsung_capacity = "128 GB";
    obj.samsung_carrier = "unlocked";
    obj.samsung_functional="";
    obj.samsung_powercord = '';
    obj.samsung_box = '';
    obj.samsung_headset = '';
    if(obj.samsung_condition==="100%"){
        customAmount=customAmount
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        if(value.capacity==="256 GB"){
            customAmount+=15
        }
        
        
    }
    if(obj.samsung_condition==="75%"){
        customAmount-=15
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }
        
        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        if(value.capacity==="256 GB"){
            customAmount+=15
        }
}
    if(obj.samsung_condition==="50%"){
    customAmount-=30
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }

        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        if(value.capacity==="256 GB"){
            customAmount+=15
        }
}
    if(condition==="Broken"){
        customAmount-=customAmount
}
}
else if(obj.samsung_model === "Galaxy Z-Flip") {
    obj.samsung_capacity = "";
    obj.samsung_carrier = "unlocked";
    obj.samsung_functional="";
    obj.samsung_powercord = '';
    obj.samsung_box = '';
    obj.samsung_headset = '';
    if(obj.samsung_condition==="100%"){
        customAmount=customAmount
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }

        
    }
    if(obj.samsung_condition==="75%"){
        customAmount-=15
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }
        
        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
        
}
    if(obj.samsung_condition==="50%"){
    customAmount-=30
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }

        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
    
}
    if(condition==="Broken"){
        customAmount-=customAmount
}
}
else if(obj.samsung_model === "Galaxy Z-Flip 5G") {
    obj.samsung_capacity = "";
    obj.samsung_carrier = "unlocked";
    obj.samsung_functional="";
    obj.samsung_powercord = '';
    obj.samsung_box = '';
    obj.samsung_headset = '';
    if(obj.samsung_condition==="100%"){
        customAmount=customAmount
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }

        
    }
    if(obj.samsung_condition==="75%"){
        customAmount-=15
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }
        
        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
        
}
    if(obj.samsung_condition==="50%"){
    customAmount-=30
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }

        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
    
}
    if(condition==="Broken"){
        customAmount-=customAmount
}
}
else if(obj.samsung_model === "Galaxy Note 20 Ultra 5G") {
    obj.samsung_capacity = "128 GB";
    obj.samsung_carrier = "unlocked";
    obj.samsung_functional="";
    obj.samsung_powercord = '';
    obj.samsung_box = '';
    obj.samsung_headset = '';
    if(obj.samsung_condition==="100%"){
        customAmount=customAmount
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        if(value.capacity==="256 GB"){
            customAmount+=15
        }

        
    }
    if(obj.samsung_condition==="75%"){
        customAmount-=15
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }
        
        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        if(value.capacity==="256 GB"){
            customAmount+=15
        }
        
}
    if(obj.samsung_condition==="50%"){
        customAmount-=30
        if(value.carrier==="Bell"  || value.carrier==="other"){
            customAmount-=30
        }
        if(value.carrier==="Fido"){
            customAmount-=15
        }
        if(value.carrier==="Rogers"){
            customAmount-=15
        }
        if(value.carrier==="Telus"){
            customAmount-=15
        }
        if(value.functional==="Yes"){
            customAmount=customAmount
        }

        if(value.functional==="No"){
            customAmount-=customAmount
        }
        if (obj.samsung_box==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_box==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_headset==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_headset==="No%") {
            customAmount -= 1;
        }
        if (obj.samsung_powercord==="Yes") {
            customAmount += 1;
        }
        if (obj.samsung_powercord==="No%") {
            customAmount -= 1;
        }
        if(value.capacity==="512 GB"){
            customAmount+=15
        }
        if(value.capacity==="256 GB"){
            customAmount+=15
        }
    
}
    if(condition==="Broken"){
        customAmount-=customAmount
}
}
        androidApi(obj).then(res => {
            if (!isEmpty(res.data && res.data.results)) {
                let offer = +res.data.results[0].offer
                offer = offer + customAmount;
                setOffers([{ ...res.data.results[0], offer }])
                if (offer <= 0) {
                    setIsBrokenOrNo(true)
                }
            }
            setIsLoader(false)
        }).catch(err => {
            console.log(err);
            setIsLoader(false)
        })
    }

    const addCart = (value) => {
        const data = {
            deviceType: "Android",
            deviceModel: value.samsung_model,
            deviceCapacity: value.samsung_capacity,
            deviceCarrier: value.samsung_carrier,
            deviceCondition: value.samsung_condition,
            deviceYear: "",
            deviceProcessor: "",
            deviceOffer: parseInt(value.offer),
            deviceGeneration: "",
            deviceSize: "",
            deviceEdition: "",
            deviceBand: "",
            deviceEngraving: "",
            imagePath: imagePath,
            id: value.id
        }
        dispatch(addToCart(data))
        props.history.push("/cart");
    }

    const devicesDetails = (value) => {
        setImagePath(value.imagePath)
        setDeviceDetails(value)
        if (value.capacity.length > 0) {
            setCapCity(true)
        } else {
            setCapCity(false)
        }
        if (value.carrier.length > 0) {
            setCarrier(true)
        } else {
            setCarrier(false)
        }
    }

    const selectIWatchCondition = (value) => {
        if (value === 'Broken') {
            setIsBrokenOrNo(false)
            setIsBrokenFiled(false)
        } else if (value === 'Brand New') {
            setIsShowButton(true)
            setIsBrokenOrNo(false)
            setIsBrokenFiled(false)
        } else if (value === 'Flaw-less') {
            setIsBrokenOrNo(false)
            setIsBrokenFiled(false)
        } else if (value === 'Good') {
            setIsBrokenOrNo(false)
            setIsBrokenFiled(false)
        } else if (value === 'Fair') {
            setIsBrokenOrNo(false)
            setIsBrokenFiled(false)
        } else {
            return null;
        }
    }

    return (
        <div className="sell-a-device-container">
            <div className={!isEmpty(selectedDevice) ? 'device-selected' : ''}>
                {
                    isEmpty(selectedDevice) &&
                    <>
                        <div className="row mt-5">
                            {
                                !isEmpty(deviceList) && deviceList.map((item, index) => (
                                    <div className={`device-item-div col-sm-4 col-md-3 d-flex flex-column cursor-pointer justify-content-space-between ${selectedDevice && selectedDevice[0].devicePhoto === item.devicePhoto ? 'active' : ''}`} key={index}>
                                        <div className="mt-2 text-center">
                                            <img height="200" src={item.devicePhoto} onClick={() => selectDevice(item)} />
                                        </div>
                                        <div className="text-center mt-1">
                                            <label className="w-100" onClick={() => selectDevice(item)} variant="warning">{item.device}</label>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </>}
            </div>
            <Formik
                initialValues={{
                    carrier: "",
                    condition: "",
                    deviceType: "",
                    functional: "",
                    box: "",
                    powercord: "",
                    headsets: "",
                    capacity: ""
                }}
                onSubmit={handelSubmits}
            >
                {({ values, handleChange }) => (
                    <Form>
                        {
                            selectedDevice &&
                            <div>
                                {selectedDevice[0].device &&
                                    <div>
                                        <div className="d-flex align-items-center">
                                            <h4 className="border border-dark-white rounded mx-2  p-4">{selectedDevice[0].device} </h4><EditIcon/> <span className="ml-2 cursor-pointer text-info h6" onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "deviceType",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "carrier",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "condition",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "capacity",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "functional",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "box",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "headsets",
                                                        value: '',
                                                    }
                                                })
                                                setSelectedDevice()
                                                setDeviceDetails()
                                                setIsBrokenFiled(false)
                                                setOffers()
                                                setIsBrokenOrNo(false)
                                                setIsShowButton(false)
                                            }} >  Change model</span>
                                        </div>
                                        {
                                            selectedDevice[0].device && !values.deviceType &&
                                            <>
                                                <hr />
                                                <div>
                                                    <h4>Select your {selectedDevice[0].device} model</h4>
                                                </div>
                                                <div role="group" className="row mt-3" aria-labelledby="my-radio-group">
                                                    {
                                                        !isEmpty(selectedDevice) && selectedDevice[0].modal.map((x, i) => (
                                                            <div className="mt-2 col-md-3 col-sm-4 text-center" key={i}>
                                                                <label className="w-100 mt-1 mr-4">
                                                                    <div className="w-100">
                                                                        <img src={x.devicePhoto} height="150" className="cursor-pointer" />
                                                                    </div>
                                                                    <Field className="mr-2" type="radio" name="deviceType" value={x.label} onClick={() => devicesDetails(x)} />
                                                                    {x.label}
                                                                </label>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </>
                                        }
                                    </div>
                                }
                                {
                                    selectedDevice[0].device && values.deviceType && <>
                                        <hr />
                                        <div className="d-flex align-items-center">
                                            <h4 className="border border-dark-white rounded mx-2  p-4" >{values.deviceType} </h4>
                                           <EditIcon/> <span className="ml-2 cursor-pointer text-info h6" onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "deviceType",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "carrier",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "condition",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "capacity",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "functional",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "box",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "headsets",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                                setDeviceDetails()
                                                setIsShowButton(false)
                                                setIsBrokenFiled(false)
                                                setIsBrokenOrNo(false)
                                            }} > Change model</span>
                                        </div>
                                        <hr />
                                        {!values.carrier && isCarrier &&
                                            <div>
                                                <h4>Select your Carrier</h4>
                                            </div>
                                        }
                                        {!values.condition && !isCarrier &&
                                            <div>
                                                <h4>Select Your condition</h4>
                                            </div>
                                        }
                                    </>
                                }


                                {selectedDevice[0].device && values.deviceType && !values.carrier && isCarrier &&
                                    <div role="group" aria-labelledby="my-radio-group">
                                        <div>
                                            {deviceDetails && deviceDetails.carrier.map((x, i) => (
                                                <>
                                                    {
                                                        (x.label != "unlocked" || x.label != "other") &&
                                                        <label className="ml-3 mt-4 cursor-pointer  border text-center border-dark-white rounded  p-4">
                                                             <Field className="mr-2 d-none" type="radio" name="carrier" value={x.label} />
                                                            <div className="mt-3">
                                                                <h4>
                                                                   {x.label}
                                                                 </h4>
                                                            </div>
                                                            <div className="margin-5">
                                                                Your're Phone is 
                                                            </div>
                                                            <div className="margin-5">
                                                               under contract
                                                           </div>
                                                            <div className="margin-5 mb-1">
                                                               with {x.label}
                                                           </div>
                                                           
                                                        </label>
                                                    }
                                                    {
                                                        x.label === "unlocked" &&
                                                        <label className="ml-3 mt-4 cursor-pointer border text-center border-dark-white rounded p-4">
                                                            <Field className="mr-2 d-none" type="radio" name="carrier" value="unlocked" />
                                                            <div className="mt-3">
                                                                <h4>
                                                                    Factory
                                                                 </h4>
                                                            </div>
                                                            <div>
                                                                <h4>
                                                                    Unlocked
                                                                 </h4>
                                                            </div>
                                                        </label>
                                                    }

                                                    {
                                                        x.label === "other" &&
                                                        <label className="ml-3 mt-4 cursor-pointer border text-center border-dark-white rounded p-4">
                                                            <Field className="mr-2 d-none" type="radio" name="carrier" value="other" />
                                                            <div>
                                                                <b>Other Carrier</b>
                                                            </div>
                                                            <div className="margin-5">
                                                                if you don't know
                                                            </div>
                                                            <div className="margin-5">
                                                                the carrier
                                                            </div>
                                                            <div className="margin-5 mb-1">
                                                                or not listed here
                                                             </div>
                                                        </label>
                                                    }
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                }
                                {
                                    selectedDevice[0].device && values.deviceType && isCarrier && values.carrier && !isCapacity && <>
                                        <div className="d-flex align-items-center">
                                            <h4 className="border border-dark-white rounded mx-2  p-4">{values.carrier} </h4>
                                           <EditIcon/> <span className="ml-2 cursor-pointer text-info h6" onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "carrier",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "condition",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "capacity",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "functional",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "box",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "headsets",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                                setIsBrokenFiled(false)
                                                setIsBrokenOrNo(false)
                                                setIsShowButton(false)
                                            }} >  Change carrier</span>
                                        </div>
                                        <hr />
                                        {values.carrier && !values.condition &&
                                            <div>
                                                <h4>Select Your condition</h4>
                                            </div>
                                        }
                                    </>
                                }

                                {
                                    selectedDevice[0].device && values.deviceType && isCarrier && values.carrier && isCapacity && <>
                                        <div className="d-flex align-items-center">
                                            <h4 className="border border-dark-white rounded mx-2  p-4"> {values.carrier} </h4>
                                          <EditIcon/>  <span className="ml-2 cursor-pointer text-info h6" onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "carrier",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "condition",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "capacity",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "functional",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "box",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "headsets",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                                setIsBrokenFiled(false)
                                                setIsBrokenOrNo(false)
                                            }} >  Change carrier</span>
                                        </div>
                                        <hr />
                                        {!values.capacity &&
                                            <div>
                                                <h4>Select the phone's capacity</h4>
                                            </div>
                                        }
                                    </>
                                }

                                {selectedDevice[0].device && values.deviceType && (isCarrier ? (values.carrier ? true : false) : true) && isCapacity && !values.capacity &&
                                    <>
                                        <div role="group" aria-labelledby="my-radio-group">
                                            <div>
                                                {
                                                    deviceDetails.capacity.map((x, i) => (
                                                        <label key={i} className="ml-4 border mt-4 cursor-pointer rounded p-4">
                                                            <Field className="mr-2 d-none" type="radio" name="capacity" onChange={handleChange} value={x} />
                                                            {x}
                                                        </label>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </>
                                }

                                {
                                    selectedDevice[0].device && values.deviceType && (isCarrier ? (values.carrier ? true : false) : true) && isCapacity && values.capacity && <>
                                        <div className="d-flex align-items-center">
                                            <h4 className="border border-dark-white rounded mx-2  p-4"> {values.capacity} </h4>
                                           <EditIcon/> <span className="ml-2 cursor-pointer text-info h6" onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "capacity",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                                setIsBrokenFiled(false)
                                            }} >  Change capacity</span>
                                        </div>
                                        <hr />
                                        {values.capacity && isCapacity && !values.condition &&
                                            <div>
                                                <h4>Select your condition</h4>
                                            </div>
                                        }
                                    </>
}                                           {values.capacity && isCapacity && !values.condition &&
                                                <div>
                                                    
                                                        {/*Modal trigger */} 
                                                            <a type="link" data-toggle="modal" data-target="#exampleModalCenter">
                                                                <span className="text-danger cursor-pointer"><u>Learn more about how to determine the condition of the Phone?</u></span></a>
                                                        {/*Modal */} 
                                                        <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                                            <div class="modal-dialog modal-dialog-centered" role="document">
                                                                <div class="modal-content">
                                                                    <div class="modal-header">
                                                                        <h5 class="modal-title" id="exampleModalLongTitle">Determine the cosmetic conditions of your Phone</h5>
                                                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                                        <span aria-hidden="true">&times;</span>
                                                                        </button>
                                                                    </div>
                                                                    <div class="modal-body">
                                                                        <p>It is important to accurately rate the physical and functional condition of your item. These conditions are crucial to helping sell my device  meet your expectations.</p>
                                                                        <p><strong>Brand new (if all of the following is true):</strong>
                                                                            <ul>
                                                                                <li> your phone is still in original packaging and sealed in the box which also includes all the accessories comes inside it.</li>
                                                                                <li> Phone is untouched.</li>
                                                                                <li> Phone's box never been opened.</li>
                                                                            </ul>
                                                                        </p>
                                                                        <p><strong>Good (if the following is true):</strong>
                                                                            <ul>
                                                                                <li>Your Phone is in great working order with some minor cosmetic signs of wear.</li>
                                                                                <li>Phone has few light marks of use, battery health must be above 90%.</li>
                                                                                <li>Phone must not have any sign of water damage or stains on outer body.</li>
                                                                            </ul>
                                                                        </p>
                                                                        <p><strong>Fair (if the following is true):</strong>
                                                                
                                                                            <ul>
                                                                                <li>  Your Phone is in  working order with several minor cosmetic signs of wear.</li>
                                                                                <li> Phone has moderate to heavy marks of use, battery health is below 90%.</li>
                                                                                <li> Phone must not have any sign of water damages.</li>
                                                                            </ul>
                                                            
                                                                        </p>
                                                                        <p><strong>Broken (if any of the following is true):</strong>
                                                                
                                                                            <ul>
                                                                                <li> Does not power on.</li>
                                                                                <li> Broken or cracked LCD screen or glass.</li>
                                                                                <li>  Missing buttons (power, home, ringer, volume).</li>
                                                                                <li> Broken or cracked hardware (charging ports, casing, etc.)
                                                                                Housing separation beyond the width of a nickel,
                                                                                have signs of water damages.</li>
                                                                            </ul>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                          </div>
                                        </div>
                                
}
                                {selectedDevice[0].device && values.deviceType && !values.condition && (isCapacity ? (values.capacity ? true : false) : true) && (isCarrier ? (values.carrier ? true : false) : true) &&
                                    <div className="row mt-3" role="group" aria-labelledby="my-radio-group">
                                        <div className="border border-dark-white rounded mx-2 w-40 h-5" >
                                            
                                        <label className={`h-100 m-2 cursor-pointer text-center  p-2 ${values.condition === "100%" && 'border border-dark rounded' || ''}`}>
                                                <Field className="mr-2 d-none"type="radio" name="condition" onClick={() => { selectIWatchCondition('Brand New')
                                                    handleChange({
                                                        target: {
                                                            name: "functional",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "box",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "powercord",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "headsets",
                                                            value: '',
                                                        }
                                                    })

                                                    setIsShowButton(true)
                                                }}  value="100%" />
                                                
                                                <div>
                                                   <h3><b>Brand new</b></h3> 
                                                </div>
                                                
                                                <div className="margin-5">
                                                    Sealed in the box
                                                </div>
                                                <div className="margin-5 ">
                                                    Comes in the original
                                                </div>
                                                <div className="margin-5 ">
                                                   company packaging
                                                </div>
                                           </label>
                                        </div>

                                        <div className="border border-dark-white rounded mx-2  w-40 h-5 ">

                                            <label className={`h-100 m-2 cursor-pointer text-center  p-2 ${values.condition === "75%" && 'border border-dark rounded' || ''}`}>
                                                <Field className="mr-2 d-none"type="radio" name="condition" value="75%" onClick={() => { selectIWatchCondition('Good')}} />
                                                <div>
                                                    <h3><b>Good</b></h3> 
                                                </div>
                                                <div>
                                                <div className="margin-5">
                                                Everything works,
                                                </div>
                                                <div className="margin-5 ">
                                                Light sign of use,
                                                </div>
                                                <div className="margin-5 ">
                                                Minimal wear & tear.
                                                </div>
                                                </div>
                                            
                                            </label>
                                        </div>

                                        <div className="border border-dark-white rounded mx-2  w-40 h-5 ">

                                            <label className={`h-100 m-2 cursor-pointer text-center  p-2 ${values.condition === "50%" && 'border border-dark rounded' || ''}`}>
                                                <Field className="mr-2 d-none"type="radio" name="condition" value="50%" onClick={() => { selectIWatchCondition('Fair')}} />
                                                <div>
                                                    <h3><b>Fair</b></h3> 
                                                </div>
                                                <div>
                                                <div className="margin-5">
                                                Everything works fine
                                                </div>
                                                <div className="margin-5 ">
                                                Moderate to heavy
                                                </div>
                                                <div className="margin-5 ">
                                                wear and tear.
                                                </div>
                                                </div>
                                            
                                            </label>
                                        </div>
                                        <div className="border border-dark-white rounded mx-2 w-40 h-5" >
                                            
                                        <label className={`h-100 m-2 cursor-pointer text-center  p-2 ${values.condition === "Broken" && 'border border-dark rounded' || ''}`}>
                                                <Field className="mr-2 d-none"type="radio" name="condition" onClick={() => { selectIWatchCondition('Broken')
                                                    handleChange({
                                                        target: {
                                                            name: "functional",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "box",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "powercord",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "headsets",
                                                            value: '',
                                                        }
                                                    })

                                                    setIsShowButton(true)
                                                }}  value="Broken" />
                                                
                                                <div>
                                                   <h3><b>Broken</b></h3> 
                                                </div>
                                                
                                                <div className="margin-5">
                                                Does not power on,
                                                </div>
                                                
                                                <div className="margin-5 ">
                                                Battery expanding 
                                                </div>
                                                <div className="margin-5 ">
                                                LCD shattered/cracked
                                                </div>
                                           </label>
                                        </div>
                                    </div>
                                }

                                {
                                    selectedDevice[0].device && values.deviceType && values.condition && (isCarrier ? (values.carrier ? true : false) : true) && (isCapacity ? (values.capacity ? true : false) : true) && <>
                                        <div className="d-flex align-items-center">
                                            <h4 className="border border-dark-white rounded mx-2  p-4">{values.condition  === "100%" ? 'Brand New' : values.condition === "75%" ? 'Good' : values.condition === "50%" ? 'Fair' : values.condition === "Broken" ? 'Faulty/Defective' : ''}  </h4>
                                          <EditIcon/> <span className="ml-2 cursor-pointer text-info h6" onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "condition",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "functional",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                                setIsShowButton(false)
                                                setIsBrokenOrNo(false)
                                            }} > Change condition</span>
                                        </div>
                                        <hr />
                                        {!values.functional && values.condition && values.condition != 'Brand New' &&
                                            <div>
                                                <h4>Select your phone fully functional</h4>
                                            </div>
                                        }
                                    </>
                                }


                                {
                                    selectedDevice[0].device && values.deviceType && values.condition && (isCarrier ? (values.carrier ? true : false) : true) && !values.functional && (isCapacity ? (values.capacity ? true : false) : true) && values.condition != 'Brand New' &&
                                    <>
                                        <div className="mt-4 col-md-12" role="group" aria-labelledby="my-radio-group">
                                            <div className="border col-md-4">
                                                <div className="float-right">
                                                    <Field className="mt-1" type="radio" name="functional" onClick={() => { setIsShowButton(true) }} value='Yes' />
                                                </div>
                                                <label className="mt-1">
                                                    Yes
                                                 </label>
                                            </div>
                                            <div className="border col-md-4">
                                                <div className="float-right">
                                                    <Field className="mt-1" type="radio" onClick={() => {
                                                        setIsBrokenOrNo(true)
                                                    }}
                                                        name="functional" value='No' />
                                                </div>
                                                <label className="mt-1">
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </>
                                }

                                {
                                    selectedDevice[0].device && values.deviceType && values.condition && (isCarrier ? (values.carrier ? true : false) : true) && values.functional && (isCapacity ? (values.capacity ? true : false) : true) && <>
                                        <div className="d-flex align-items-center">
                                            <h4 className="border border-dark-white rounded mx-2  p-4"> {values.functional} </h4>
                                           <EditIcon/> <span className="ml-2 cursor-pointer text-info h6" onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "functional",
                                                        value: '',
                                                    }
                                                })
                                                setIsBrokenOrNo(false)
                                                setIsShowButton(false)
                                                setOffers()
                                            }} > Change phone functionality</span>
                                        </div>
                                        <hr />
                                        {!isBrokenOrNo && isEmpty(offers) &&
                                            <div>
                                                <h4>Select your phone accessories</h4>
                                            </div>
                                        }
                                    </>
                                }

                                {
                                    !isBrokenOrNo && isEmpty(offers) && selectedDevice[0].device && values.deviceType && values.condition && (isCarrier ? (values.carrier ? true : false) : true) && (isCapacity ? (values.capacity ? true : false) : true) && values.functional &&
                                    <div className="row">
                                        <div className="mt-4 col-md-12">
                                            <div className="border col-md-4">
                                                <div className="float-right">
                                                    <Field className="mt-1" onChange={handleChange} checked={values.box} type="checkbox" name="box" />
                                                </div>
                                                <label className="mt-1">
                                                    Include Original Box
                                                </label>
                                            </div>
                                            <div className="border col-md-4">
                                                <div className="float-right">
                                                    <Field className="mt-1" onChange={handleChange} checked={values.headsets} type="checkbox" name="headsets" />
                                                </div>
                                                <label className="mt-1">
                                                    New Original Headsets
                                                </label>
                                            </div>
                                            <div className="border col-md-4">
                                                <div className="float-right">
                                                    <Field className="mt-1" onChange={handleChange} type="checkbox" checked={values.powercord} name="powercord" />
                                                </div>
                                                <label className="mt-1">
                                                    include Charging Cable and Adaptor
                                               </label>
                                            </div>
                                        </div>
                                    </div>

                                }

                                {
                                    !isBrokenOrNo && selectedDevice[0].device && values.deviceType && values.condition && (isCarrier ? (values.carrier ? true : false) : true) && values.functional && (isCapacity ? (values.capacity ? true : false) : true) && !isEmpty(offers) &&
                                    <>
                                        <div>
                                            <h4 >Accessories Includes :</h4>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div>
                                                <h4 className="border border-dark-white rounded mx-2  p-4">{values.box && "Yes" || "No"} </h4>
                                            </div>

                                         <EditIcon/>   <span className="ml-2 cursor-pointer text-info h6" onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "box",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                            }} > Change  box includes</span>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div>
                                                <h4 className="border border-dark-white rounded mx-2  p-4">
                                                   {values.headsets && "Yes" || "No"}</h4>
                                            </div>
                                          <EditIcon/>  <span className="ml-2 cursor-pointer text-info h6" onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "headsets",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                            }} > Change headsets includes </span>
                                        </div>

                                        <div className="d-flex align-items-center">
                                            <div>
                                                <h4 className="border border-dark-white rounded mx-2  p-4">{values.powercord && "Yes" || "No"}</h4>
                                            </div>
                                           <EditIcon/> <span className="ml-2 cursor-pointer text-info h6" onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                            }} >  Change charger includes </span>
                                        </div>
                                    </>
                                }
                                {
                                    ((values.condition === 'Brand New' && !values.functional && isShowButton && isEmpty(offers)) ||
                                        (isEmpty(offers) && (isCarrier ? (values.carrier ? true : false) : true) && (isCapacity ? (values.capacity ? true : false) : true) && selectedDevice[0].device && values.condition && values.functional && !isBrokenFiled && isShowButton)) &&
                                    <div className="col-md-12">
                                        <div className="d-flex justify-content-center">
                                            <div className="col-md-6 mt-4 text-center">
                                                <Button variant="outline-secondary" className="w-100" type="submit">Show my Offer</Button>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {
                                    isBrokenFiled && isShowButton &&
                                    <div className="col-md-12">
                                        <div className="d-flex justify-content-center">
                                            <div className="col-md-6 mt-4 text-center">
                                                <Button variant="outline-secondary" className="w-100" onClick={() => {
                                                    setIsBrokenOrNo(true)
                                                    setIsBrokenFiled(false)
                                                }} >Show my Offer</Button>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {isLoader && isEmpty(offers) &&
                                    <div className="text-center col-md-12">
                                        <LoaderSpinner></LoaderSpinner>
                                    </div>
                                }

                                {!isEmpty(offers) && !isBrokenOrNo &&
                                    <div className="mt-4 col-md-12 text-center">
                                        <div className="d-flex justify-content-center">
                                            <div className="col-md-2">
                                                <h1 className="border p-4 m-0">
                                                    $ {offers[0].offer}
                                                </h1>
                                                <div className="border-right p-1 border-bottom border-left">
                                                    <h5 className="mt-1">Your Offer </h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <div className="mt-4 col-md-6">
                                                <Button variant="outline-primary" className="w-100" onClick={() => addCart(offers[0])} type="submit">Sell Now</Button>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <p className="mb-0">*Offered value of the device is subject to device review </p>
                                            <p className="mb-0">We may requote you with higher offer value if we find the cosmetic condition of the device better than what you thought of and vice versa </p>
                                            <p className="mb-0">We process the payment immediately after receiving your device we offer free express shipping. </p>
                                            <p className="mb-0">We don’t pay for the devices that have been reported lost or stolen</p>
                                        </div>
                                    </div>
                                }

                                {isBrokenOrNo &&
                                    <div className="mt-4 col-md-12 text-center">
                                        <div className="mt-3 bg-custom-danger">
                                            <p className="mb-0">Currently we’re not able to offer any value for the selected device in described condition but </p>
                                            <p className="mb-0">we can safely recycle it in a way which won’t harm environment in any way and leave zero carbon footprint but</p>
                                            <p className="mb-0">We’re glad to offer you $5 bonus on you next device trade/sell worth in offer value more than $100 use promocode RECYCLE at checkout to avail the bonus. </p>
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <div className="mt-4 col-md-6">
                                                <Button variant="outline-primary" className="w-100"
                                                    onClick={() => addCart({
                                                        offer: 0,
                                                        samsung_capacity: values.capacity,
                                                        samsung_carrier: values.carrier,
                                                        samsung_condition: values.condition,
                                                        id: values.condition,
                                                        imagePath: imagePath,
                                                        samsung_model: values.deviceType
                                                    })}
                                                >Recycle now</Button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </Form>
                )}
            </Formik>
        </div >
    )
}

export default AndroidPage
